const TenantInvoices = () => import("./views/TenantInvoices.vue");

export default [
  {
    path: "/tenantInvoices",
    name: "tenantInvoices",
    component: TenantInvoices,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
